module.exports = __webpack_public_path__ + "media/images/logo-d5295b5586e6e60bed40be29035d2755.png";